module.exports = __webpack_public_path__ + "static/media/jordanfloatflipped.4c2ee811.png";